// accordion
jQuery(function($) {
  var $accordion = $('.js-accordion');
  if ($accordion.length) {
    // var $accordionTrigger = $accordion.children('.p-accordion__head');
    // $accordionTrigger.on('click', function() {
    //   $(this).parent('.js-accordion').toggleClass('is-active');
    // });
    //変数
    var
      $accordionTrigger = $accordion.find('.p-accordion__head'),
      $acordionTarget = $accordionTrigger.next();
    $accordionTrigger.on("click", function(){
      $acordionTarget = $(this).next();
      if ($acordionTarget.is(':hidden')) {
        $(this).parent().addClass('is-active');
        // $acordionTarget.fadeIn(400);
        $acordionTarget.slideDown(400);
      } else {
        $(this).parent().removeClass('is-active');
        // $acordionTarget.fadeOut(400);
        $acordionTarget.slideUp(400);
      }
      // if (window.matchMedia('screen and (max-width: 767px)').matches) {
      //   if($(this).parent().find('.s-job-gallery__list').length) {
      //     $(this).parent().find('.s-job-gallery__list').slick('setPosition');
      //     // console.log('hogeeeegegege');
      //   }
      // }
    });
  }
});
